import React, { useState, useMemo, useEffect } from 'react'
import { Col, Row, Button, Form, Modal, Tab, Tabs } from 'react-bootstrap'

import TableGrid from "../../../Components/common/TableGrid";
import { DELETERECEMAIL, SAVEHANDLER, STATIONLIST, ULDADDRESSRECMAIL } from '../../../Utils/conts';
import { toast } from 'react-toastify';
import { CallApi } from '../../../Components/common/CommonFunctions';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { ReactComponent as ArchiveIcon } from "../../../assets/images/slotplanning/archive_icon.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCircleXmark, faTrashCan, faPencil, faEnvelope, } from '@fortawesome/free-solid-svg-icons';
import { useGetStationSettingsDetailQuery } from '../../../redux/services/SRC';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedRowsData } from '../../../redux/features/table/tableSlice';
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import AddStationHandler from '../../../Components/common/AddStationHandler';

const StationDetails = ({ propData, reload, isModal, modalData }) => {
    const [tb, setTb] = useState("1");
    const dispatch = useDispatch();
    const columns = [
        { label: 'Handler Name', field: 'handler_name', },
        {
            label: 'Recovery Emails', field: 'total_emails',
            // renderCell: (row) => {
            //     const chkEmail = row?.handler_email_id?.filter(i => i !== '')
            //     return (
            //         <div>
            //             {chkEmail?.length}
            //         </div>
            //     );
            // },
        },
        {
            label: 'Default Handler', field: 'handler_phone_no',
            renderCell: (row) => {
                return (
                    <div>
                        {row?.is_default_handler === 1 ? 'Yes' : 'No'}
                    </div>
                );
            },
        },
        // { label: 'Address', field: 'address', },
    ];
    const tabs = [
        { label: "Active", value: "1" },
        { label: "Archive", value: "0" }
    ]
    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
    const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value); // [187,186]
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };
    const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);
        const params = {
            station_id: propData?.station_id,
            activity_status: tb,
            ...filterParams,
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
        };
        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }
        if (tab?.value && tab.key) {
            params[tab.key] = tab.value;
        }
        return params;
    }, [filters, pageDetails, sortby, tb]);
    const { data: myData, isFetching, refetch } = useGetStationSettingsDetailQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
    });

    const [selectedRowData, setSelectedRowData] = useState(null);

    const [show, setShow] = useState(false);
    // const storedData = propData?.args.Address;
    const initInput = { handler_name: '', handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: '' }
    const [inputAddress, setInputAddress] = useState(initInput);
    const [sendData, setSendData] = useState({});

    const modalShow = () => {
        setEditMode('A');
        setInputAddress(initInput);
        setSendData({
            frmData: initInput,
            station_id: propData.station_id,
            title: 'Add Address - ' + propData?.port_code,
            subTitle: 'Create a new address for this station'
        })
        setShow(true);
    }
    const modalClose = () => setShow(false);
    const handleModalSubmit = (data) => {
        if (editMode === 'E') { setSelectedRowData(data); }
        reload()
        refetch()
        modalClose();
    }
    const handleRowClick = (data) => {
        console.log('data', data);

        setSelectedRowData(data);
        setItems(data.additional_emails)
        // setShowDetails(true);
        const transformedData = {
            ...data,
            agent_type: data.regd,
            email: data.contact_email
        };
        setSelectedAddress(transformedData)
    }

    const [selectedAddress, setSelectedAddress] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [handlerList, setHandlerList] = useState([]);
    const [editMode, setEditMode] = useState('');

    const modalEditShow = (data) => {
        // console.log('data', data);

        // setShowEdit(true);
        setEditMode('E')
        setInputAddress(data)
        setSendData({
            frmData: data,
            station_id: propData.station_id,
            title: 'Edit Address - ' + propData?.port_code,
            subTitle: 'Edit the existing address for this station'
        })
        setShow(true);
    }

    useEffect(() => {
        if (modalData) {
            setSelectedRowData(modalData)
            setItems(modalData?.additional_emails)
        }
    }, [])
    // Email section
    const emailArray = selectedRowData && selectedRowData.recovery_emails;
    // console.log("🚀 ~ StationDetails ~ emailArray:", emailArray)
    const [emailShow, setEmailShow] = useState(false);
    const inputEmailShow = () => setEmailShow(true);
    const [inputData, setInputData] = useState("");
    const [items, setItems] = useState([]);
    const [editEmail, setEditEmail] = useState(null);
    const [toggleButton, setToggleButton] = useState(false);
    
    const closeEmailShow = () => {
        setEmailShow(false);
        setInputData('')
    }
    const AddEmail = async () => {
        if (inputData == '') {
            // Alert('Please input Email');
            console.log("Please input Email");
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
            return;
        }
        let payload;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!validateEmail(inputData)) {
            toast.error('Invalid email address');
            setEmailShow(true);
            return;
        }
        if (inputData && toggleButton) {
            const filterItem = items.filter((i, index) => index !== editEmail)
            const recEmail = [inputData, ...filterItem]
            payload = { ...selectedRowData, additional_emails: recEmail }
        } else {
            const recEmail = items?.length ? [inputData, ...items] : [inputData]
            payload = { ...selectedRowData, additional_emails: recEmail }
        }
        // console.log('pl', payload);
        
        // }
        CallApi({
            endPoint: SAVEHANDLER,
            payload: payload,
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    toast.success(res.data.response_msg)
                    setSelectedRowData(innerData);
                    setItems(innerData.additional_emails)
                    setEmailShow(false);
                    if (inputData && toggleButton) {
                        setInputData('');
                        setEditEmail(null);
                        setToggleButton(false);
                    }
                    refetch()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const deleteEmail = async (index) => {
        const filterItem = items.filter((i, idx) => idx !== index)
        const payload = { ...selectedRowData, additional_emails: filterItem }

        CallApi({
            endPoint: SAVEHANDLER,
            payload: payload,
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    toast.success(res.data.response_msg);
                    setSelectedRowData(innerData);
                    setItems(innerData.additional_emails);
                    refetch()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    // Email section End

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.handler_email_id];
            updatedEmails[index] = value;
            return { ...prev, handler_email_id: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: [...prev.handler_email_id, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: prev.handler_email_id.filter((_, i) => i !== index)
        }));
    };
    // Email array end
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };

    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_name) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        else {
            return isValid;
        }
    };
    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateFormData()) {
            e.preventDefault();
            // const newAddressID = Math.floor(Math.random() * 1000000);
            const stationid = propData.station_id;
            const NewInputAddress = { ...inputAddress, handler_contact_id: inputAddress.handler_contact_id ?? inputAddress.id, station_id: stationid };

            const dataToSend = {
                station_id: stationid,
                company_name: inputAddress.company_name,
                agent_or_handler: inputAddress.agent_or_handler,
                address: inputAddress.address,
                email: inputAddress.email,
                phone_number: inputAddress.phone_number
            };
            // console.log("🚀 ~ addAddress ~ dataToSend:", dataToSend)

            if (inputAddress.agent_or_handler === 'A') {
                dataToSend.agent_type = inputAddress.agent_type;
            }

            // const updatedAddress = [...address, NewInputAddress];
            // if (updatedAddress) {
            //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
            //   }
            if (NewInputAddress) {
                CallApi({
                    endPoint: SAVEHANDLER,
                    payload: NewInputAddress,
                    onSuccess: (res) => {
                        if (res.data.response_code == 200) {
                            refetch()
                            // setAddress(res.data.response_data);
                            setInputAddress({
                                handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
                            });
                            setSelectedRowData(res.data.response_data)
                            modalClose();
                            reload()
                            refetch()
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    },
                    onError: (msg) => toast.error(msg)
                });

            }

        }
    }
    const handleTabChange = (key) => {
        setTb(key);
    };
    const handleArchive = async (rows) => {
        try {
            const ids = rows.map((r) => r.handler_contact_id);
            const payload = {
                handler_contact_id: ids,
                action: tb === "1" ? "0" : "1"
            };
            CallApi({
                endPoint: "station-details-move-archive",
                payload: payload,
                onSuccess: (res) => {
                    const resCode = res?.data?.response_code;
                    if (resCode === 200) {
                        toast.success("Status updated");
                        refetch();
                        dispatch(clearSelectedRowsData(true));
                    } else {
                        toast.error(res?.data?.response_msg || "Updation failed");
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        } catch (err) {
            toast.error("Updation failed");
        }
    };
    const bulkActions = tb == "1"
        ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
        : tb == "0"
            ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
            : [];
    const changeDefault = () => {
        CallApi({
            endPoint: SAVEHANDLER,
            payload: { ...selectedRowData, is_default_handler: selectedRowData.is_default_handler === 1 ? 0 : 1 },
            onSuccess: (res) => {
                if (res.data.response_code == 200) {
                    refetch()

                    setSelectedRowData(res.data.response_data)
                    // modalClose();
                    // reload()
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }


    return (
        <>
            {console.log("inputData", inputData)}
            {console.log("emailShow", emailShow)}
            {!isModal &&
                <div className='mange_adrs'>
                    <div className='adrs_right'>
                        <div className='d-flex justify-content-between'>
                            <div>
                                <h5>Manage Address </h5>
                                <p>Manage Address and add address</p>
                            </div>
                            <div className='align-self-center'>
                                <button onClick={modalShow} className='add_adres'>+ Add Address</button>
                            </div>
                        </div>
                        <Tabs id="station-tabs"
                            activeKey={tb}
                            onSelect={handleTabChange}
                            className="booking_tab">
                            {tabs?.map((tab) => (
                                <Tab
                                    eventKey={tab.value}
                                    key={tab.value}
                                    title={
                                        <>
                                            <span>
                                                {tab.label}
                                                {/* <span className="rabadge badge bg-primary ms-2 ssss">{tab.doors_count}</span> */}
                                            </span>
                                        </>
                                    }
                                />
                            ))}
                        </Tabs>

                        <div className='setting_table'>
                            <TableGrid
                                columns={columns}
                                rows={myData?.Rows}
                                checkboxSelection={true}
                                totalRecords={propData?.address?.length || 0}
                                onClickRow={(row) => handleRowClick(row)}
                                // loading={isFetching}
                                rowKey='handler_contact_id'
                                bulkActions={bulkActions}
                            />
                        </div>


                    </div>
                    <div className='adrs_left'>
                        {/* {console.log('selectedRowData', selectedRowData)} */}
                        {selectedRowData && (
                            <>
                                <div className='handler_name'>
                                    <div className='raedit'><Button variant="link" onClick={() => modalEditShow(selectedRowData)}><FontAwesomeIcon icon={faPencil} /> Edit Handler </Button></div>
                                    <h2>{selectedRowData.handler_name}</h2>

                                    <div className='handler_info'>
                                        <ul>
                                            <h3>Handler Information</h3>
                                            {/* <li><span>Agent/Handler </span> : <span>{selectedRowData.agent_or_handler == 'A' ? 'Agent' : 'Handler'}, {selectedRowData.address_2} </span></li>
                                    <li><span>Registered Hub</span> : <span>{selectedRowDatar.egd == '1' ? 'Registered' : 'Non Registered'}</span></li> */}
                                            <li><span>Contact Email </span> : <span> {selectedRowData.handler_email_id}</span></li>
                                            <li><span>Phone No </span> : <span>{selectedRowData.handler_phone_no}</span></li>
                                            <li><span>Address </span> : <span>{selectedRowData.address}</span></li>

                                        </ul>
                                    </div>
                                </div>
                                <div className='mt-0'>
                                    <div className='py-2'>
                                        <h6>Default Handler</h6>
                                        <p className='d-flex align-items-center mb-0 green_check'>
                                            <Form.Check
                                                type="checkbox"
                                                checked={selectedRowData.is_default_handler === 1}
                                                onChange={changeDefault}
                                            />

                                            <span className='ps-2'>Default Handler for {propData?.port_code}</span>
                                        </p>

                                    </div>
                                </div>

                                <div className='mt-2'>
                                    <div className='d-flex justify-content-between align-items-center py-2'>
                                        <h6 className='mb-0'>Recovery Email Address</h6>
                                        <div className='align-self-center'>
                                            <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                                        </div>

                                    </div>
                                    <div className='addresses'>
                                        {emailShow &&
                                            <>
                                                <div className='add_email'>
                                                    <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                                    {toggleButton ? <button onClick={AddEmail}>Edit</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                                </div>
                                            </>
                                        }
                                        <div className='showItem'>
                                            {selectedRowData.additional_emails && selectedRowData?.additional_emails?.map((elem, index) => {
                                                return (
                                                    <div className='eachItem' key={index}>
                                                        <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                                        {/* <button>Edit</button> */}
                                                        <div className='request_email'>
                                                            <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                            <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* <ImageUpload attachable_type={"uld_s_address"} attachable_id={selectedRowData.address_id} attachments={selectedRowData.attachments} /> */}
                            </>
                        )}
                        {show && <AddStationHandler propData={sendData} modalClose={modalClose} modalSubmit={handleModalSubmit} />}
                        {/* <Modal show={show} onHide={modalClose} centered className='modal_bgw primary_modal' backdrop="static">
                        <Modal.Header closeButton onClick={modalClose}>
                            <Modal.Title>
                                {editMode == 'E' ? 'Edit Address' : `Add Address - ${propData?.port_code}`}
                                <p>{editMode == 'E' ? 'Edit the existing' : 'Create a new'} address for this station</p>
                                </Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <Form.Group className='mb-1'>
                                <Form.Label>Handler Name <span className='red'>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={handleChange}
                                    name='handler_name'
                                    value={editMode === 'E' ? selectedRowData?.handler_name : inputAddress.handler_name}
                                    placeholder="Handler Name"
                                    disabled={editMode === 'E'}
                                /> */}
                        {/* <Select
                                    options={handlerList}
                                    onChange={(selected) => {
                                        setInputAddress(prevFormData => {
                                            const newFormData = { ...prevFormData, handler_org_id: selected.value, handler_email_id: selected.email };
                                            return newFormData;
                                        });
                                    }}
                                    placeholder="Select Handler"
                                    className='select_handler'
                                    name='handler_org_id'
                                    value={handlerList.find(option => option.value == inputAddress.handler_org_id) || ''}
                                /> */}
                        {/* </Form.Group>

                            <Form.Group className='mb-1 position-relative'>
                                <Form.Label>Contact Email ID</Form.Label> */}

                        {/* <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link> */}
                        {/* <Form.Control type="text" onChange={handleChange} name='handler_email_id' placeholder="E-mail" /> */}

                        {/* {inputAddress?.handler_email_id?.map((email, index) => (
                                    <div key={index} className="d-flex align-items-center position-relative">
                                        <Form.Control
                                            type="text"
                                            placeholder="Contact Email ID"
                                            value={email}
                                            onChange={(e) => handleEmailChange(index, e.target.value)}
                                            className=""
                                        />
                                        {inputAddress.handler_email_id.length > 1 && (

                                            <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>

                                        )}
                                    </div>
                                ))}
                            </Form.Group>

                            <Form.Group className='mb-1'>
                                <Form.Label>Address </Form.Label>
                                <Form.Control type="text" onChange={handleChange} name='address' placeholder="Address" value={inputAddress?.address || ''} />
                            </Form.Group>

                            <Form.Group className='mb-1'>
                                <Form.Label>Telephone No</Form.Label>
                                <Form.Control
                                    type="number"
                                    onChange={handleChange} name='handler_phone_no'
                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
                                    placeholder="Number"
                                />
                            </Form.Group>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={addAddress} className='defult_save' >
                                <SaveIcon /> {editMode == 'E' ? 'Update' : 'Save'} 
                            </Button>
                        </Modal.Footer>
                    </Modal> */}
                    </div>
                </div>
            }

            {isModal &&
                <div className='mt-2'>
                    <div className='d-flex justify-content-between align-items-center py-2'>
                        <h6 className='mb-0'>Recovery Email Address</h6>
                        <div className='align-self-center'>
                            {emailShow ?
                                <button onClick={closeEmailShow} className='add_adres'>Close</button>
                                :
                                <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                            }
                        </div>

                    </div>
                    <div className='addresses'>
                        {emailShow &&
                            <>
                                <div className='add_email'>
                                    <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                    {toggleButton ? <button onClick={AddEmail}>Save</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                </div>
                            </>
                        }
                        <div className='showItem'>
                            {selectedRowData?.additional_emails && selectedRowData?.additional_emails?.map((elem, index) => {
                                return (
                                    <div className='eachItem' key={index}>
                                        <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                        {/* <button>Edit</button> */}
                                        <div className='request_email'>
                                            <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                            <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default StationDetails